import { Fragment } from 'react'
import {useRouter} from '../../../_app/hooks/useRouter'
const Breadcrumbs = ({category}) => {
    const breadcrumbs = category?.breadcrumbs ? [...category.breadcrumbs].sort((a, b) => a.category_level - b.category_level) : []
    let category_url_key = ''
    const { locale } = useRouter()
    const style: any = {
        box: {
            display: 'block',
            width: '100%',
            marginBottom: '20px',
        },
        span: {
            marginLeft: '3px',
            marginRight: '3px',
        },
        hr: {
            marginTop: '15px',
            marginBottom: '5px',
            marginRight: '20px',
            width: 'calc(100% - 20px)',
        }
    }
    return (
        <>
            {breadcrumbs?.length > 1 && (
                <div style={style.box}>
                    {breadcrumbs?.map((el, index) => {
                        category_url_key += '/' + el?.category_url_key
                        const formattedCategoryUrlKey = category_url_key.startsWith('/')
                            ? category_url_key.substring(1)
                            : category_url_key
                        const href = `/${locale ? `${locale}/` : ''}${formattedCategoryUrlKey}.html`
                        return (
                            <Fragment key={index}>
                                <a href={href} title={el?.category_name || ''}>
                                    {el?.category_name}
                                </a>
                                {index + 1 !== breadcrumbs?.length && (
                                    <span style={style.span}>/</span>
                                )}
                            </Fragment>
                        )
                    })}
                    <hr style={style.hr} />
                </div>
            )}
        </>
    )
}

export default Breadcrumbs